import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './FAQPage.css'
import { Link } from 'react-router-dom';

function InfoElementEng() {
   return (
      <div className='acordion_wrapper' >
         <Accordion className='acordion' defaultExpanded={true} disabled={true}>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography>The purpose and goal of the project <br /> (English please)</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography >
                  The purpose of this project is: <br />
                  1. Collection of financial aid for the Armed Forces of Ukraine and/or orphanages; <br />
                  2. Supporting young developers in this difficult time. Our goal is to create a platform where young, talented and ambitious developers can spread their knowledge, skills and experience with other project participants and everyone; <br />
                  3. Mix business with pleasure. We realise that software development and the IT industry in general can be exhausting, so we strive to add entertaining content that makes this world more interesting. We believe that a combination of entertaining and useful content will help attract more participants to the project and make it more attractive to a wider audience. <br />
                  <br />
                  <br />
                  <br />
               </Typography>
            </AccordionDetails>
         </Accordion>
         <Accordion className='acordion'>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel1a-content"
               id="panel1a-header"
            >
               <Typography>
                  General information about the event
               </Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>
                  IT developers participate in the event and present their pet projects.
                  <br />
                  <br />
                  Each event lasts about 5-6 days, which can be checked in more detail on the countdown board on the <Link style={{color:"rgb(59, 59, 211)", borderBottom:"1px solid"}} to='/info' target={"_blank"}>page</Link> with the participants' projects.
                  <br />
                  <br />
                  At the end of the event, three winners will be determined with the help of the votes of all those who are not indifferent.
                  <br />
                  <br />
                  Voting takes place in the <a target={"_blank"} style={{color:"rgb(59, 59, 211)", borderBottom:"1px solid"}} href="https://t.me/the_way_of_junior">Telegram channel</a> , which can be accessed via a link on the main page or directly from any participant's block.
                  <br />
                  <br />
                  Charitable funds to support the Armed Forces and/or orphanage, as well as to promote participants, can be transferred via the <a target={"_blank"} style={{color:"rgb(59, 59, 211)", borderBottom:"1px solid"}} href="https://send.monobank.ua/jar/5rJky3qhy9">link</a> on the main page or directly from any participant's block. All raised money will be donated to support selected charities and the winners of the event.
                  <br />
                  <br />
                  Each event is a separate vote and a separate fundraising.
                  <br />
                  <br />
                  After each event, the winners will be determined and the money will be transferred to a designated charity fund.
<br />
<br />
<br />
               </Typography>
            </AccordionDetails>
         </Accordion>
         <Accordion className='acordion'>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography>Rules of participation</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>
                  Developers who meet the following categories can participate: <br />
                  1. Frontend developer <br />
                  2. Has no commercial experience (at all); <br />
                  3. Has a pet project that he wants to share with the world: <br />
                  - pet project created independently; <br />
                  - pet project uploaded to GIT; <br />
                  - pet project has a link to the working version; <br />
                  4. Ready to make a symbolic contribution to the prize fund; <br />
                  5. The participant must provide information (name, surname, screenshot of the project, Linkedin link, working link to the project, link to GIT where the project is located). <br />
                  6. The organizers of the event reserve the right to reject any application.
<br />
<br />
<br />
               </Typography>
            </AccordionDetails>
         </Accordion>
         <Accordion className='acordion'>
            <AccordionSummary
               expandIcon={<ExpandMoreIcon />}
               aria-controls="panel2a-content"
               id="panel2a-header"
            >
               <Typography>Prize fund</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>
                  At the end of the event, the charity fund will be distributed as follows: <br />
                  - 50% of the raised money will be transferred to a fund chosen by the organizers to support the Armed Forces of Ukraine or an orphanages; <br />
                  - the remaining funds will be divided between the three winners according to their place in the competition. The first place winner will receive 50% of the remaining funds raised, and the second and third place winners will receive 25% each.
<br />
<br />
<br />

               </Typography>
            </AccordionDetails>
         </Accordion>
      </div>
   );
}

export default InfoElementEng;